jQuery(document).ready(function(){
// menu
	window.onscroll = function() {
      myFunction()
    };
  var navbar = document.getElementById("header-sticky");
  var sticky = navbar ? navbar.offsetTop : 0;
  function myFunction() {
    if (!navbar) return false;
    if (!navbar.length) return false;
    if (window.pageYOffset >= sticky) {
      navbar.classList.add("sticky")
    } else {
      navbar.classList.remove("sticky");
    }
  }
  // setTimeout(function() { 
  //   $('.section-top-text .items').marquee({
  //     pauseOnHover: 'true',
  //     duration: 15000,
  //     delayBeforeStart: 0,
  //     direction: 'left'
  //   });
  //   $(".section-top-text .items ").css("opacity", "1");
  // }, 1000);

//   abstractt
	$(".scents-to-support .img-icon").matchHeight();
  
//   menu dropdow
	 $('.dm.lv1').click(function(){
       $(this).find('.mob-scroller').slideToggle();
       $(this).parent().siblings().children('.dm.lv1').find('.mob-scroller').slideUp(500);
       $(this).toggleClass('active');
       $(this).parent().siblings().children('.dm.lv1').removeClass('active');
//Mobile
       $(this).find('.dropdown-mobile').slideToggle();
       $(this).parent().siblings().children('.dm.lv1').find('.dropdown-mobile').slideUp(500);
       $(this).parent().siblings().children('.dm.lv1').removeClass('active');
    });
})